export default __webpack_public_path__ + "static/media/snils.db86f661.svg";